import { Stack, Typography } from "@mui/material";

import type { FC } from "react";

export const TemplateSubject: FC<{ subject?: string }> = ({ subject }) => (
  <Stack direction="row" gap={1}>
    <Typography variant="body2" color="text.secondary">
      Subject:
    </Typography>
    <Typography variant="body1">{subject}</Typography>
  </Stack>
);
